module.exports = __webpack_public_path__ + "img/person-square.0f3c47da.svg";